/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://j7tk6uqobbf6xoif2uersnck5m.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-oos5w7vrpbebbcseugh6bjztqe",
    "aws_cloud_logic_custom": [
        {
            "name": "api1",
            "endpoint": "https://phczj9c39b.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:f965a6db-8206-47e9-8ed3-875cd4ffe2ef",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_ss8g9YgZR",
    "aws_user_pools_web_client_id": "1ib8426i6gceqsn0dind7flcn0",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "GIVEN_NAME",
        "FAMILY_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "parakeet-storage-8fec0562224911-staging",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
